import { Col, Collapse, Icon, Row, Table } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ButtonStandard from "../../../../components/utils/button";
import TagStatus from "../../../../components/utils/tagStatus";
import { Creators as ReportActions } from "../../../../store/ducks/report";
import { CardCustom, Title } from "./styles";

// Hooks
import { useFinancial } from "../../../../hooks/useFinancialReducer";

// Services
import ProcessTransferAnimalTransactionModal from "../../../../components/modals/processTransferAnimalTransactionModal";
import ViewTransferAnimalTransactionModal from "../../../../components/modals/viewTransferAnimalTransactionModal";
import EyeIcon from "../../../../components/utils/icons/eye";
import BigPencilIcon from "../../../../components/utils/icons/pencil/big";
import { findAllTransferAnimalTransactions } from "../../../../services/transferAnimalTransactionService";
import FarmProductionSellTable from "./table";

const { Column } = Table;

const customPanelStyle = {
  borderRadius: 7,
  background: "#fff",
  boxShadow: "0px 0px 10px #d8d8d8",
  marginBottom: 15,
};

const FarmProductionSell = () => {
  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId, confinement: isFarmConfinement },
  } = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const [
    isLoadingTransferAnimalTransactions,
    setIsLoadingTransferAnimalTransactions,
  ] = useState(false);

  const [transferAnimalTransactions, setTransferAnimalTransactions] = useState(
    []
  );
  const [transferAnimalTransactionData, setTransferAnimalTransactionData] =
    useState();
  const [
    isModalProcessTransferAnimalTransactionVisible,
    setIsModalProcessTransferAnimalTransactionVisible,
  ] = useState(false);
  const [
    isModalViewTransferAnimalTransactionVisible,
    setIsModalViewTransferAnimalTransactionVisible,
  ] = useState(false);

  // Redux
  const { isLoadingFarmSells, refreshListFarmSells } = useFinancial();

  const handleGetTransferAnimalTransactions = useCallback(async () => {
    setIsLoadingTransferAnimalTransactions(true);
    try {
      const {
        data: { results },
      } = await findAllTransferAnimalTransactions({
        groupId,
        farmId,
      });
      setTransferAnimalTransactions(results);
    } catch (error) {
    } finally {
      setIsLoadingTransferAnimalTransactions(false);
    }
  }, [farmId, groupId]);

  const handleRefresh = useCallback(() => {
    refreshListFarmSells();
    handleGetTransferAnimalTransactions();
  }, [handleGetTransferAnimalTransactions, refreshListFarmSells]);

  const handleOpenCloseModalReport = () => {
    dispatch(ReportActions.showModal("FarmSalesReport"));
  };

  const handleOpenCloseModalConfinementResultReport = () => {
    dispatch(ReportActions.showModal("IntensiveResultReport"));
  };

  const handleOpenCloseModalProcessTransferAnimalTransaction = () => {
    setIsModalProcessTransferAnimalTransactionVisible((old) => !old);
  };

  const handleOpenCloseModalViewTransferAnimalTransaction = () => {
    setIsModalViewTransferAnimalTransactionVisible((old) => !old);
  };

  const handleClickToViewTransferAnimalTransaction = useCallback((record) => {
    setTransferAnimalTransactionData(record);
    handleOpenCloseModalViewTransferAnimalTransaction();
  }, []);

  const handleClickTransferAnimalTransaction = useCallback((record) => {
    if (record.status === "Pending") {
      setTransferAnimalTransactionData(record);
      handleOpenCloseModalProcessTransferAnimalTransaction();
    }
  }, []);

  // Effects
  useEffect(() => {
    handleGetTransferAnimalTransactions();
  }, [handleGetTransferAnimalTransactions]);

  return (
    <CardCustom>
      <Row type="flex" justify="space-between" className="rowHeader">
        <Col>
          <Title>{translation.financial.animalSell.title}</Title>
        </Col>
        <Col>
          <Row type="flex">
            <div className="colButtons">
              <ButtonStandard
                buttonType="typeWithoutBackground"
                disabled={isLoadingFarmSells}
                onClick={handleRefresh}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </div>
            {isFarmConfinement && (
              <div className="colButtons">
                <ButtonStandard
                  name="buttonExportTransactions"
                  buttonType="alternative"
                  onClick={handleOpenCloseModalConfinementResultReport}
                >
                  Resultado de Confinamento
                </ButtonStandard>
              </div>
            )}
            <div className="colButtons">
              <ButtonStandard
                name="buttonExportTransactions"
                buttonType="alternative"
                onClick={handleOpenCloseModalReport}
              >
                {translation.financial.animalSell.buttonExport}
              </ButtonStandard>
            </div>
            <div className="colButtons">
              <Link to="/admin/productionSell/new">
                <ButtonStandard name="buttonCreateBudget" buttonType="addNew">
                  {translation.financial.animalSell.buttonNew}
                </ButtonStandard>
              </Link>
            </div>
          </Row>
        </Col>
      </Row>
      {/* Transfer Panel */}
      {transferAnimalTransactions && transferAnimalTransactions.length > 0 && (
        <Row type="flex">
          <Collapse
            defaultActiveKey={"1"}
            bordered={false}
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? (
                <i>
                  <Icon
                    type="up"
                    style={{ fontSize: "15px", color: "#684E94" }}
                  />
                </i>
              ) : (
                <i>
                  <Icon
                    type="down"
                    style={{ fontSize: "15px", color: "#684E94" }}
                  />
                </i>
              )
            }
          >
            <Collapse.Panel
              key={"1"}
              header={
                <h3>{translation.financial.animalSell.transferPanelTitle}</h3>
              }
              style={customPanelStyle}
            >
              <Table
                size="small"
                pagination={false}
                loading={isLoadingTransferAnimalTransactions}
                dataSource={transferAnimalTransactions}
                rowKey={"id"}
              >
                <Column
                  dataIndex="status"
                  title={
                    translation.financial.animalSell.transferPanelTable.columns
                      .status
                  }
                  render={(text) =>
                    text === "Pending" ? (
                      <TagStatus
                        className="status"
                        background="#FFF6EE"
                        borderColor="#FE8D2A"
                        color="#FE8D2A"
                      >
                        {translation.status.pending}
                      </TagStatus>
                    ) : text === "Processing" ? (
                      <TagStatus
                        className="status"
                        background="#EBF7FF"
                        borderColor="#4A85AE"
                        color="#4A85AE"
                      >
                        {translation.status.processing}
                      </TagStatus>
                    ) : text === "Error" ? (
                      <Icon
                        type="exclamation-circle"
                        className="iconError"
                        theme="filled"
                      />
                    ) : text === "Completed" ? (
                      <TagStatus
                        background="#E1FFE4"
                        borderColor="#106518"
                        color="#106518"
                      >
                        {translation.status.processed}
                      </TagStatus>
                    ) : text === "Refused" ? (
                      <TagStatus
                        className="status"
                        background="#FBC7C7"
                        borderColor="#D44C4C"
                        color="#D44C4C"
                      >
                        {translation.status.refused}
                      </TagStatus>
                    ) : null
                  }
                />
                <Column
                  dataIndex="originGroupName"
                  title={
                    translation.financial.animalSell.transferPanelTable.columns
                      .originGroupName
                  }
                />
                <Column
                  dataIndex="originFarmName"
                  title={
                    translation.financial.animalSell.transferPanelTable.columns
                      .originFarmName
                  }
                />
                <Column
                  dataIndex="amountAnimals"
                  title={
                    translation.financial.animalSell.transferPanelTable.columns
                      .amountAnimals
                  }
                />
                <Column
                  render={(text, record) => {
                    return (
                      <Row type="flex" gutter={8}>
                        <ButtonStandard
                          buttonType="typeWithoutBackground"
                          onClick={() =>
                            handleClickToViewTransferAnimalTransaction(record)
                          }
                        >
                          <EyeIcon isActive />
                        </ButtonStandard>
                        {record.status === "Pending" && (
                          <ButtonStandard
                            buttonType="type6"
                            style={{
                              fontSize: 18,
                              display: "flex",
                              gap: 16,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            onClick={() =>
                              handleClickTransferAnimalTransaction(record)
                            }
                          >
                            <BigPencilIcon color={"#FFF"} />{" "}
                            {translation.buttons.edit}
                          </ButtonStandard>
                        )}
                      </Row>
                    );
                  }}
                />
              </Table>
            </Collapse.Panel>
          </Collapse>
        </Row>
      )}
      {/* Sales Table */}
      <FarmProductionSellTable />
      <ProcessTransferAnimalTransactionModal
        transferAnimalTransactionData={transferAnimalTransactionData}
        modalVisible={isModalProcessTransferAnimalTransactionVisible}
        closeModal={handleOpenCloseModalProcessTransferAnimalTransaction}
      />
      <ViewTransferAnimalTransactionModal
        transferAnimalTransactionData={transferAnimalTransactionData}
        modalVisible={isModalViewTransferAnimalTransactionVisible}
        closeModal={handleOpenCloseModalViewTransferAnimalTransaction}
      />
    </CardCustom>
  );
};

export default FarmProductionSell;
